import { render, staticRenderFns } from "./FileApproval.vue?vue&type=template&id=0786cbe0"
import script from "./FileApproval.vue?vue&type=script&lang=js"
export * from "./FileApproval.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports